"use client";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import BackIcon from "@public/icons/back-icon.svg";
import { useRouter } from "next/navigation";

type BackButtonProps = {
  label: string;
  // historyBack, onClick, pathnameはこの順番で優先され、有効なパラメータがある場合には後のものは無視される
  // どれも無ければhistoryBack相当の挙動をする
  historyBack?: boolean;
  onClick?: () => void;
  pathname?: string;
  className?: string;
};

export const BackButton = ({
  label,
  pathname,
  onClick,
  className,
  historyBack,
}: BackButtonProps) => {
  const router = useRouter();
  return (
    <Button
      variant="ghost"
      className={cn("h-auto px-3 py-1 text-sm font-bold", className)}
      onClick={() => {
        if (historyBack) {
          router.back();
        } else if (onClick) {
          onClick();
        } else if (pathname) {
          router.push(pathname);
        } else {
          router.back();
        }
      }}
      type="button"
    >
      <span className="inline-flex size-9 items-center justify-center rounded-full border">
        <BackIcon />
      </span>
      <span className="ml-3">{label}</span>
    </Button>
  );
};
